import { spacingFluidMd, spacingFluidXl, spacingStaticLg } from "@porsche-design-system/components-react/emotion"
import type { PropsWithChildren } from "react"
import { Grid } from "src/components/grid/Grid"

export const PricingFormGrid = ({ children }: PropsWithChildren) => (
	<Grid $columnGap={{ base: spacingFluidMd, s: spacingFluidXl }} $rowGap={spacingStaticLg}>
		{children}
	</Grid>
)
